import { render } from "./OfertaPage.vue?vue&type=template&id=2cf4c224"
import script from "./OfertaPage.vue?vue&type=script&lang=js"
export * from "./OfertaPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__